import React, { FC } from 'react';
import { DnsTableContext } from '../context';
import { useDnsTable } from '../hooks/use-dns-table';
import { NextTable } from '@shared/modules/next-table/containers';

export const DnsTable: FC = () => {
  const { columns, getRowProps } = useDnsTable();

  return <NextTable context={DnsTableContext} getRowProps={getRowProps} columns={columns} />;
};
